import type { Quote } from '../api/types'
import { PublishQuoteAction as PublishQuote } from '../publishing/publish-quote'

/** The current-quote bar's publish control: publish a draft for the customer (USA-1028). */
export function PublishQuoteAction({ quote }: { quote: Quote }) {
  return <PublishQuote quote={quote} />
}
